import { useState } from 'react';
import ConfirmationModal from 'components/ConfirmationModal/ConfirmationModal';
import useToast from 'hooks/useToast';
import { useUpdateProFormaSubprojectLink } from 'queries/ProForma/useUpdateProFormaSubprojectLink';

export const UNLINK_PROJECT_MODAL_HEADER = 'Unlink project';
export const UNLINK_PROJECT_CONFIRMATION_TEXT = 'Are you sure you want to unlink this development project? '
    + 'The project will remain in Northspyre, but project actuals will no longer appear on this pro forma.';

export interface IUnlinkProjectModalProps {
    isOpen: boolean;
    toggle: () => void;
    dealId: number;
    proFormaId: number;
    onUnlinked?: () => void;
}

const UnlinkProjectModal = ({
    isOpen,
    toggle,
    dealId,
    proFormaId,
    onUnlinked,
}: IUnlinkProjectModalProps) => {
    const { showSuccess } = useToast();
    const [isUnlinking, setIsUnlinking] = useState(false);
    const { mutate: updateSubprojectLink } = useUpdateProFormaSubprojectLink();

    const handleUnlink = () => {
        if (isUnlinking) return;
        setIsUnlinking(true);
        updateSubprojectLink({ dealId, proFormaId, subprojectUuid: null }, {
            onSuccess: () => {
                showSuccess('Project unlinked successfully');
                onUnlinked?.();
                toggle();
            },
            onSettled: () => setIsUnlinking(false),
        });
    };

    return (
        <ConfirmationModal
            isOpen={isOpen}
            toggle={toggle}
            danger
            modalHeaderText={UNLINK_PROJECT_MODAL_HEADER}
            modalFooterButtonText="Unlink"
            modalFooterButtonColor="danger"
            modalFooterCancelButtonText="Cancel"
            onConfirm={handleUnlink}
            modalFooterIsButtonFunctionDisabled={isUnlinking}
            modalFooterButtonIsLoading={isUnlinking}
        >
            <div className="text-white">{UNLINK_PROJECT_CONFIRMATION_TEXT}</div>
        </ConfirmationModal>
    );
};

export default UnlinkProjectModal;
